<template>
  <div>
    <a-form-model layout="horizontal" :model="model" v-bind="{labelCol: { span: 4 },wrapperCol: { span: 14 },}" ref="ruleForm">
      <a-form-model-item  label='周期配置类型' prop='periodRule' >
        <a-radio-group v-model='model.periodRule' :options="[{ label: '统一规则', value: '1' }]"   />
      </a-form-model-item>
      <a-form-model-item  :label='item.name' prop='ddd' v-for="(item,index) in model.itemList1" :key="index">
        <a-radio-group v-model='item.periodRule' :options="radios"   />
        <a-select v-model='item.periodItemId' placeholder='请选择周期' v-if="item.periodRule==='4'">
          <a-select-option :value='pitem.id' :key="pitem.id" v-for="pitem in periodItemList">{{pitem.name}}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item  :label='item.name' prop='ddd' v-for="(item,index) in model.itemList3" :key="item.name+index">
        <a-radio-group v-model='item.periodRule' :options="radios"   />
        <a-select v-model='item.periodItemId' placeholder='请选择周期' v-if="item.periodRule==='4'">
          <a-select-option :value='pitem.id' :key="pitem.id" v-for="pitem in periodItemList">{{pitem.name}}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item  :label='item.name' prop='ddd' v-for="(item,index) in model.itemList4" :key="item.name+index">
        <a-radio-group v-model='item.periodRule' :options="radios"   />
        <a-select v-model='item.periodItemId' placeholder='请选择周期' v-if="item.periodRule==='4'">
          <a-select-option :value='pitem.id' :key="pitem.id" v-for="pitem in periodItemList">{{pitem.name}}</a-select-option>
        </a-select>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
import { getAction } from '@/api/manage'
export default {
  name: 'Step3',
  components: {  },
  data() {
    return {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 10 }
      },
      rules: {
      },
      radios:[{ label: '基线周期', value: '1' },{ label: '相同周期', value: '2' }, { label: '上一周期', value: '3' }, { label: '指定周期', value: '4' }],
      model:{},
      periodItemList:[]
    }
  },
  created() {
  },
  methods: {
    view(model){
      model.periodRule = model.periodRule || '1'
      if(model.itemList1){
        model.itemList1.forEach(item=>{
          item.periodRule = item.periodRule || '2'
        })
      }
      if(model.itemList3){
        model.itemList3.forEach(item=>{
          item.periodRule = item.periodRule || '2'
        })
      }
      if(model.itemList4){
        model.itemList4.forEach(item=>{
          item.periodRule = item.periodRule || '2'
        })
      }
        this.model = JSON.parse(JSON.stringify(model))
        this.periodRuleChange()
    },
    insertStr(source, start, newStr) {
      return source.slice(0, start) + newStr + source.slice(start)
    },
    getRadioText(value,periodItemId){
      let name = ''
      this.radios.forEach(item=>{
        if(item.value===value){
          name = item.label
        }
      })
      if(value==='4'){
        this.periodItemList.forEach(pItem=>{
          if(pItem.id===periodItemId){
            name = name + '.' + pItem.name
          }
        })
      }
        return name
    },
    /**
     * 当前步骤表单验证逻辑
     */
    validate() {
      let result = false
      this.$refs.ruleForm.validate((valid, errorFields) => {
        if (valid) {
          if(this.model.itemList1){
            this.model.itemList1.forEach(item=>{
              item.name = item.name.replace(".基线周期】","】")
              item.name = item.name.replace(".相同周期】","】")
              item.name= item.name.replace(".上一周期】","】")
              if(item.name.indexOf(".指定周期")>-1){
                item.name = item.name.replace(item.name.substring(item.name.indexOf('.指定周期'),item.name.length-1),'')
              }
              if(!(item.name.endsWith(`.基线周期】`)||item.name.endsWith(`.相同周期】`)||item.name.endsWith(`.上一周期】`) || item.name.indexOf(".指定周期")>-1)){
                item.name = this.insertStr(item.name,item.name.length-1,`.${this.getRadioText(item.periodRule,item.periodItemId)}`)
              }
            })
          }
          if(this.model.itemList3){
            this.model.itemList3.forEach(item=>{
              item.name = item.name.replace(".基线周期】","】")
              item.name = item.name.replace(".相同周期】","】")
              item.name= item.name.replace(".上一周期】","】")
              if(item.name.indexOf(".指定周期")>-1){
                item.name = item.name.replace(item.name.substring(item.name.indexOf('.指定周期'),item.name.length-1),'')
              }
              if(!(item.name.endsWith(`.基线周期】`)||item.name.endsWith(`.相同周期】`)||item.name.endsWith(`.上一周期】`) || item.name.indexOf(".指定周期")>-1)){
                item.name = this.insertStr(item.name,item.name.length-1,`.${this.getRadioText(item.periodRule,item.periodItemId)}`)
              }
            })
          }
          if(this.model.itemList4){
            this.model.itemList4.forEach(item=>{
              item.name = item.name.replace(".基线周期】","】")
              item.name = item.name.replace(".相同周期】","】")
              item.name= item.name.replace(".上一周期】","】")
              if(item.name.indexOf(".指定周期")>-1){
                item.name = item.name.replace(item.name.substring(item.name.indexOf('.指定周期'),item.name.length-1),'')
              }
              if(!(item.name.endsWith(`.基线周期】`)||item.name.endsWith(`.相同周期】`)||item.name.endsWith(`.上一周期】`) || item.name.indexOf(".指定周期")>-1)){
                item.name = this.insertStr(item.name,item.name.length-1,`.${this.getRadioText(item.periodRule,item.periodItemId)}`)
              }
            })
          }
          result = true
        }
      })
      return result
    },
    periodRuleChange(){
      if(this.periodItemList.length===0){
        getAction('/project/projectPeriodItem/list',{projectId:this.model.projectId,halfway:'0'}).then(res=>{
          if(res.success){
            this.periodItemList=res.result
          }
        })
      }
    },
  }
}
</script>

<style scoped>

</style>
